import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addInterpreter, interpreterSelector, setError, updateInterpreter, fetchInterpreters } from "slices/interpreterSlice";
import ErrorMessage from "components/common/ErrorMessage";
import toast from "react-hot-toast";
import { CustomSwitch } from "components/common/Switch";
import { SubmitButton } from "components/common/buttons/SubmitButton";

const AddInterpreterForm = ({ item, handleClose, callback, show, statusPerm }) => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
  } = useForm();
  const { error, loader } = useSelector(interpreterSelector);
  const [status, setStatus] = useState(1);

  const clearAll = () => {
    setValue("first_name", "");
    setValue("last_name", "");
    setValue("email", "");
    setValue("password", "");
    setStatus(1);
    dispatch(setError({}));
  };

  useEffect(() => {
    setValue("first_name", item?.first_name || "");
    setValue("last_name", item?.last_name || "");
    setValue("email", item?.user?.email || "");
    setValue("password", "");
    setStatus(typeof item?.status === "number" ? item?.status : 1);
    return () => clearAll();
  }, [item]);

  const submitCallback = (success, message) => {
    if (success) {
      callback();
      toast.success(message, { className: "successToast" });
      dispatch(fetchInterpreters());
      handleClose();
    } else {
      toast.error(message, { className: "errorToast" });
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}));
    const payload = { ...data, status };
    if (item?.id) {
      dispatch(updateInterpreter(payload, item?.id, submitCallback));
    } else {
      dispatch(addInterpreter(payload, submitCallback));
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row-primary">
          <h2>First Name *</h2>
          <Controller
            name="first_name"
            control={control}
            rules={{ required: "First name is required" }}
            render={({ field }) => (
              <input
                className="input-in type_inp"
                type="text"
                placeholder="First name"
                {...field}
              />
            )}
          />
          {errors?.first_name?.message && (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={errors.first_name.message} />
            </div>
          )}
        </div>

        <div className="row-primary">
          <h2>Last Name</h2>
          <Controller
            name="last_name"
            control={control}
            render={({ field }) => (
              <input
                className="input-in type_inp"
                type="text"
                placeholder="Last name"
                {...field}
              />
            )}
          />
        </div>

        <div className="row-primary">
          <h2>Email *</h2>
          <div className="w-100">
            <Controller
              name="email"
              control={control}
              rules={{ required: "Email is required" }}
              render={({ field }) => (
                <input
                  className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""}`}
                  type="email"
                  autoComplete="off"
                  placeholder="Email Address"
                  {...field}
                />
              )}
            />
            {error?.errors?.email?.map((e, i) => (
              <div key={i} style={{ marginBottom: 10 }}>
                <ErrorMessage text={e} />
              </div>
            ))}
            {errors?.email?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors.email.message} />
              </div>
            )}
          </div>
        </div>

        <div className="row-primary">
          <h2>Password {item?.id ? "" : "*"}</h2>
          <div className="w-100">
            <input
              className="input-in type_inp"
              type="password"
              autoComplete="off"
              placeholder="Password"
              {...register("password", !item?.id ? { required: "Password is required" } : {})}
            />
            {error?.errors?.password?.map((e, i) => (
              <div key={i} style={{ marginBottom: 10 }}>
                <ErrorMessage text={e} />
              </div>
            ))}
            {errors?.password?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors.password.message} />
              </div>
            )}
          </div>
        </div>

        {statusPerm && (
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2 className="mt-0">Status</h2>
            <CustomSwitch
              labelText="active"
              checked={status === 1}
              handleChange={(checked) => setStatus(checked ? 1 : 0)}
            />
          </div>
        )}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">
            Cancel
          </button>
          <SubmitButton loader={loader} btnText={item?.id ? "Update" : "Create"} />
        </div>
      </form>
    </div>
  );
};

const AddInterpreter = ({ item, onClose, callback, show, statusPerm }) => {
  const closeButton = useRef(null);
  const refModal = useRef(null);
  const handleModalDismiss = () => {
    closeButton.current.click();
    onClose();
  };
  useEffect(() => {
    const modalElement = refModal.current;
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleModalDismiss);
    }
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleModalDismiss);
      }
    };
  }, []);

  return (
    <div
      className="modal fade"
      ref={refModal}
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Interpreter</h5>
            <button
              onClick={handleModalDismiss}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddInterpreterForm
              item={item}
              handleClose={handleModalDismiss}
              callback={callback}
              show={show}
              statusPerm={statusPerm}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddInterpreter;
